// VIP Signup Interest Survey
// Prompts a brand-new member, once, for domain/seat/review-interest and a
// free-text "where do you currently read about this" answer - never at
// signup itself (Portal stays untouched, email-only), only immediately
// after it completes.
//
// Posts straight to the same Apps Script Web App endpoint vip-gate.js and
// vip-contact.js already use (type: 'signup_survey'), so the answers land
// in the site owner's own Google Sheet - queryable/exportable there, no
// Ghost Admin API involved (this project has none - see CLAUDE.md).
//
// WHY the reveal is gated the way it is: Ghost's theme layer exposes no
// @member.created_at or @member.labels (confirmed against Ghost's theme
// docs before building this), so there is no server-side way to tell "a
// member who just joined" from "a member who joined months ago." The one
// reliable native signal is the query string Ghost's own magic-link
// redirect appends right after a signup completes - ?action=signup&
// success=true (or action=subscribe, depending on which Portal trigger
// was used). Gating on that means existing members, who never carry
// those params on an ordinary visit, structurally never see this at all
// - not a frequency cap layered on top, but the actual mechanism.
//
// The localStorage flag is set the instant the prompt is shown (not on
// submit/skip), so an abandoned page load - closed tab, navigated away -
// still counts as "seen" and never resurfaces it on a later visit.

(function() {
    'use strict';

    var ENDPOINT = 'https://script.google.com/macros/s/AKfycbxfIJoTyVhaa1_rS4yLIuAH-p7mMhWyobj6VT5PAHY3k8UhPNTxp19oYh3QTM8kkGYy/exec';
    var TOKEN = 'VIPCommits20261234321';
    var STORAGE_KEY = 'vip_signup_survey_seen';
    var FRESH_SIGNUP_ACTIONS = ['signup', 'subscribe'];

    function isFreshSignup() {
        try {
            var params = new URLSearchParams(window.location.search);
            var action = params.get('action');
            var success = params.get('success');
            return success === 'true' && FRESH_SIGNUP_ACTIONS.indexOf(action) !== -1;
        } catch (e) {
            return false;
        }
    }

    // Strips action/success from the visible URL so a refresh doesn't
    // read as a fresh signup again - belt-and-braces alongside the
    // localStorage flag, not a substitute for it (the flag is what
    // actually prevents re-showing; this just keeps the address bar clean).
    function cleanUrl() {
        try {
            var url = new URL(window.location.href);
            url.searchParams.delete('action');
            url.searchParams.delete('success');
            window.history.replaceState({}, document.title, url.toString());
        } catch (e) {}
    }

    function hasSeenSurvey() {
        try {
            // Fail closed: if storage is unavailable (private browsing,
            // disabled), treat it as already seen rather than risk
            // showing it on every single visit.
            return window.localStorage.getItem(STORAGE_KEY) === '1';
        } catch (e) {
            return true;
        }
    }

    function markSeen() {
        try { window.localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }

    function collectDomains(form) {
        var boxes = form.querySelectorAll('input[name="domains"]:checked');
        return Array.prototype.map.call(boxes, function(box) { return box.value; });
    }

    function showStatus(statusEl, kind, message) {
        statusEl.textContent = message;
        statusEl.classList.remove('is-success', 'is-error');
        statusEl.classList.add(kind === 'success' ? 'is-success' : 'is-error');
    }

    function closeSurvey(container) {
        container.hidden = true;
        container.classList.remove('is-visible');
    }

    function submitSurvey(container, form, submitBtn, statusEl) {
        var email = container.getAttribute('data-member-email') || '';
        var seatEl = form.querySelector('input[name="seat"]:checked');
        var reviewEl = form.querySelector('input[name="review_interest"]:checked');

        submitBtn.disabled = true;
        form.classList.add('is-submitting');

        fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify({
                type: 'signup_survey',
                token: TOKEN,
                email: email,
                domains: collectDomains(form),
                seat: seatEl ? seatEl.value : '',
                review_interest: reviewEl ? reviewEl.value : '',
                discovery: form.discovery.value.trim(),
                website: form.website.value
            })
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            if (data.ok) {
                showStatus(statusEl, 'success', '[[PLACEHOLDER: thanks message]]');
                setTimeout(function() { closeSurvey(container); }, 1400);
            } else {
                showStatus(statusEl, 'error', data.error || '[[PLACEHOLDER: error message]]');
            }
        }).catch(function() {
            showStatus(statusEl, 'error', "[[PLACEHOLDER: couldn't confirm this was sent - message]]");
        }).finally(function() {
            submitBtn.disabled = false;
            form.classList.remove('is-submitting');
        });
    }

    function initSurvey(container) {
        var form = container.querySelector('.vip-signup-survey-form');
        var closeBtn = container.querySelector('.vip-signup-survey-close');
        var skipBtn = container.querySelector('.vip-signup-survey-skip');
        var statusEl = container.querySelector('.vip-signup-survey-status');
        var submitBtn = container.querySelector('.vip-signup-survey-submit');

        if (!form || !statusEl || !submitBtn || !form.discovery || !form.website) {
            console.warn('[vip-signup-survey] malformed markup, leaving hidden:', container);
            return;
        }

        if (!isFreshSignup() || hasSeenSurvey()) {
            return;
        }

        markSeen();
        cleanUrl();

        container.hidden = false;
        container.classList.add('is-visible');

        if (closeBtn) {
            closeBtn.addEventListener('click', function() { closeSurvey(container); });
        }
        if (skipBtn) {
            skipBtn.addEventListener('click', function() { closeSurvey(container); });
        }
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            submitSurvey(container, form, submitBtn, statusEl);
        });
    }

    function init() {
        try {
            var container = document.getElementById('vip-signup-survey');
            if (!container) { return; }
            try {
                initSurvey(container);
            } catch (e) {
                console.warn('[vip-signup-survey] failed to initialize:', e);
            }
        } catch (e) {
            console.warn('[vip-signup-survey] top-level init failed:', e);
        }
    }

    // Bootstrapping wrapped per CLAUDE.md §7: all theme JS concatenates
    // into one casper.js, so this guards against this component's own
    // setup throwing and taking down anything concatenated after it.
    try {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
    } catch (e) {
        console.warn('[vip-signup-survey] failed to bootstrap:', e);
    }
})();
